import {getAbsoluteUrl} from "../../utils/urlUtill";


export class ConditionService {

    constructor($http, $log) {
        this.$http = $http;
        this.$log = $log;
    }

    getCondition = (conditionId) => {
        let calculatorConditionUrl = `api/calculators/conditions/${conditionId}`;
        return this.$http({
            method: 'GET',
            cache: true,
            url: getAbsoluteUrl(calculatorConditionUrl)
        }).then((resp) => {
            this.$log.debug('Received the calculation condition with id ', conditionId);
            return resp;
        })
    };

    updateCondition = condition => {
        let calculatorConditionUrl = `api/calculators/conditions/${condition.id}`;
        return this.$http({
            method: 'PUT',
            url: getAbsoluteUrl(calculatorConditionUrl),
            data: condition
        })
            .then(resp => {
                this.$log.debug('Updated the condition with id ', condition.id);
                return resp;
            })
    };


    static instance = ['$http', '$log', ConditionService];

}